<ts-dialog title="Add Property" (closeDialog)="discard()">
  <main ts-dialog-body class="flex flex-col flex-1 w-full">
    <form [formGroup]="propertyForm">
      <section class="flex flex-col flex-1">
        <mat-form-field class="flex-auto">
          <mat-label>Property Name</mat-label>
          <input
            matInput
            [formControlName]="'name'"
            [placeholder]="'Property Name'"
            [spellcheck]="false"
            [readonly]="isOptionsLoading"
          />
          @if (propertyForm.get('name').hasError('required') && propertyForm.get('name').touched) {
            <mat-hint>Property name is required.</mat-hint>
          }
        </mat-form-field>

        <div class="flex flex-col gt-xs:flex-row">
          <mat-form-field class="flex-auto">
            <mat-label>Property Type</mat-label>
            <mat-select [formControlName]="'property_type_id'" [disabled]="isOptionsLoading">
              @for (propertyType of propertyTypes; track propertyType.id) {
                <mat-option [value]="propertyType.id">{{ propertyType.name }}</mat-option>
              }
            </mat-select>
            @if (
              propertyForm.get('property_type_id').hasError('required') && propertyForm.get('property_type_id').touched
            ) {
              <mat-hint>Property type is required.</mat-hint>
            }
          </mat-form-field>
        </div>

        <div class="flex flex-col gt-xs:flex-row">
          <mat-form-field class="flex-auto">
            <mat-label>Deal Layout</mat-label>
            <mat-select [formControlName]="'template_id'" [disabled]="isOptionsLoading">
              <mat-option [value]="null">None</mat-option>
              @for (template of propertyTemplates; track template.id) {
                <mat-option [value]="template.id">{{ template.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex flex-col gt-xs:flex-row">
          <fieldset class="w-full" [formGroupName]="'address'">
            <mat-form-field class="flex-auto w-full">
              <mat-label>Address</mat-label>
              <input
                matInput
                google-place
                [placeholder]="'Address'"
                [formControlName]="'address_string'"
                (onSelect)="setAddress($event)"
                (onSelectParts)="onSelectAddressParts($event)"
                autocomplete="none"
                [disabled]="isOptionsLoading"
              />
            </mat-form-field>
            <div class="flex flex-col gt-xs:flex-row gap-2">
              <mat-form-field class="flex-auto">
                <mat-label>City</mat-label>
                <input matInput [formControlName]="'city'" />
              </mat-form-field>
              <mat-form-field class="flex-auto">
                <mat-label>State</mat-label>
                <input matInput [formControlName]="'state'" />
              </mat-form-field>
              <mat-form-field class="flex-auto">
                <mat-label>Zip</mat-label>
                <input matInput [formControlName]="'postal_code'" />
              </mat-form-field>
            </div>
          </fieldset>
        </div>
      </section>
    </form>
  </main>

  <footer ts-dialog-actions class="ts-dialog-actions-container">
    <ts-button variant="secondary" (buttonClick)="discard()">Cancel</ts-button>
    <ts-button variant="primary" [disabled]="isSaveBtnDisabled" (buttonClick)="saveProperty()">
      @if (!isLoading) {
        Create and Save
      } @else {
        Saving...
      }
    </ts-button>
  </footer>
</ts-dialog>
